import React from "react";


const HolidayCard = ({
  holiday,
  onClick,
  isDarkMode,
  screenSize,
  fonts,
  spacing,
  theme,
  t,
}) => {
  // Example: use a default icon for holidays
  const TypeIcon = theme?.holidayIcon;
  const cardStyle = {
    background: isDarkMode
      ? "rgba(255, 255, 255, 0.08)"
      : "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(25px)",
    WebkitBackdropFilter: "blur(25px)",
    border: isDarkMode
      ? "2px solid rgba(255, 255, 255, 0.1)"
      : "2px solid rgba(0, 0, 0, 0.05)",
    borderRadius: screenSize === "xs" ? "16px" : "24px",
    padding: screenSize === "xs" ? "20px" : "28px",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
  };

  return (
    <div style={cardStyle}>
      {/* Background decoration */}
      <div
        style={{
          position: "absolute",
          top: "-30px",
          left: "-30px",
          width: screenSize === "xs" ? "60px" : "100px",
          height: screenSize === "xs" ? "60px" : "100px",
          borderRadius: "50%",
          filter: "blur(25px)",
        }}
      />

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: screenSize === "xs" ? "12px" : "16px",
          marginBottom: screenSize === "xs" ? "16px" : "24px",
          position: "relative",
          zIndex: 2,
          flexDirection: screenSize === "xs" ? "column" : "row",
          textAlign: screenSize === "xs" ? "center" : "left",
        }}
      >
        <div
          style={{
            width: screenSize === "xs" ? "48px" : "64px",
            height: screenSize === "xs" ? "48px" : "64px",
            background:
              `linear-gradient(135deg, #2e7cba, #2e7cba)` /* blue gradient */,
            borderRadius: screenSize === "xs" ? "16px" : "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: `0 8px 24px #2e7cba30`,
            flexShrink: 0,
          }}
        >
          {/* You can use a static icon for holidays, e.g. Gift icon from lucide-react */}
          <svg width={screenSize === "xs" ? 20 : 28} height={screenSize === "xs" ? 20 : 28} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M12 7V21"/><path d="M2 7V5a2 2 0 0 1 2-2h2.5a2.5 2.5 0 0 1 0 5H2z"/><path d="M22 7V5a2 2 0 0 0-2-2h-2.5a2.5 2.5 0 0 0 0 5H22z"/></svg>
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <h3
            style={{
              color: isDarkMode ? "white" : "#1a1a1a",
              fontSize: screenSize === "xs" ? fonts.body : fonts.subtitle,
              fontWeight: "600",
              margin: "0 0 6px 0",
              textShadow: isDarkMode ? "0 2px 4px rgba(0,0,0,0.3)" : "none",
              fontFamily: "'Cairo', sans-serif",
            }}
          >
            {holiday.name}
          </h3>
          <p
            style={{
              color: isDarkMode
                ? "rgba(255, 255, 255, 0.6)"
                : "rgba(26, 26, 26, 0.6)",
              fontSize: screenSize === "xs" ? fonts.tiny : fonts.small,
              margin: 0,
              lineHeight: 1.4,
              fontFamily: "'Cairo', sans-serif",
            }}
          >
            {holiday.localName || holiday.description || holiday.date}
          </p>
        </div>
      </div>

      {/* Date and extra info */}
      <div
        style={{
          marginTop: screenSize === "xs" ? "8px" : "16px",
          color: isDarkMode ? "#fff" : "#1a1a1a",
          fontSize: fonts.small,
          fontWeight: 500,
          fontFamily: "'Cairo', sans-serif",
        }}
      >
        {new Date(holiday.date).toLocaleDateString(
          t.language === "ar" ? "ar-EG" : "en-US",
          { weekday: "short", month: "long", day: "numeric" }
        )}
      </div>
    </div>
  );
};

export default HolidayCard;